import * as t from 'io-ts';
import {
  Breadcrumb,
  CabTypesAvailableForRent,
  Faq,
  RouteInfo
} from '../../../src/pages/runtime-typechecker';

export const ReadMoreData = t.type({
  title: t.string,
  shortDescription: t.string,
  description: t.string
});
export type ReadMoreDataType = t.TypeOf<typeof ReadMoreData>;
export const AirportHomePageTemplateData = t.type({
  templateName: t.union([t.undefined, t.string]),
  metaTitle: t.string,
  metaDescription: t.string,
  metaKeywords: t.string,
  sampleUrl: t.string,
  analytics: t.string,
  footerData: t.string,
  h1Title: t.string,
  extraInfo: t.string,
  breadcrumb: t.array(Breadcrumb),
  externalJs: t.string,
  faq: t.array(Faq),
  bannerDesktop: t.union([t.undefined, t.string]),
  bannerMobile: t.union([t.undefined, t.string]),
  descriptionInHtml: t.union([t.undefined, t.string])
});

export type AirportHomePageTemplateData = t.TypeOf<
  typeof AirportHomePageTemplateData
>;

export const NameUrl = t.type({
  name: t.union([t.string, t.null, t.undefined]),
  url: t.union([t.string, t.null, t.undefined]),
  code: t.union([t.string, t.null, t.undefined])
});

export const CityWithRouteUrls = t.type({
  cityName: t.string,
  cityUrl: t.union([t.undefined, t.string]),
  routeUrlsList: t.array(RouteInfo)
});

export const PopularCitiesWithRoutes = t.array(CityWithRouteUrls);

export const AirportHomePageTemplateDataChecker = t.type({
  pushToCache: t.boolean,
  cacheKey: t.string,
  status: t.string,
  footerData: t.string,
  routesFromAirportCities: PopularCitiesWithRoutes,
  templateData: AirportHomePageTemplateData,
  primaryAirportList: t.union([t.array(NameUrl), t.undefined]),
  cabTypesAvailableForRent: CabTypesAvailableForRent,
  hrPackages: t.union([t.array(t.string), t.undefined])
});

export type AirportHomePageData = t.TypeOf<
  typeof AirportHomePageTemplateDataChecker
>;
